import { useNavigate } from 'react-router-dom';
import StatusBadge from './StatusBadge';
import { formatShortDate } from '../../utils/formatDate';
import { User, ArrowUp, ArrowDown } from 'lucide-react';

export default function RegistrationTable({ data, sortBy, sortOrder, onSort }) {
  const navigate = useNavigate();

  const handleSort = (col) => {
    if (sortBy === col) {
      onSort(col, sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      onSort(col, 'asc');
    }
  };

  const SortHeader = ({ col, children }) => (
    <th
      onClick={() => handleSort(col)}
      className="text-left py-3 px-3 text-ysrcp-100 font-medium text-xs uppercase tracking-wider cursor-pointer hover:text-white whitespace-nowrap transition-colors"
    >
      <span className="inline-flex items-center gap-1">
        {children}
        {sortBy === col && (
          sortOrder === 'asc'
            ? <ArrowUp className="w-3 h-3" />
            : <ArrowDown className="w-3 h-3" />
        )}
      </span>
    </th>
  );

  return (
    <div className="overflow-x-auto bg-white rounded-xl shadow-panel border border-gray-100">
      <table className="min-w-[900px] w-full text-sm">
        <thead className="sticky top-0 bg-gradient-to-r from-ysrcp-600 to-ysrcp-500">
          <tr>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs w-10">#</th>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs w-10">Photo</th>
            <SortHeader col="full_name">Name</SortHeader>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs">User ID</th>
            <SortHeader col="status">Status</SortHeader>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs">Committee</th>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs">Position</th>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs">Mandal</th>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs">Phone</th>
            <th className="py-3 px-3 text-left text-ysrcp-100 font-medium text-xs">Voter ID</th>
            <SortHeader col="created_date">Created</SortHeader>
          </tr>
        </thead>
        <tbody>
          {data.map((reg, i) => (
            <tr
              key={reg.id}
              onClick={() => navigate(`/registrations/${reg.id}`)}
              className={`border-b border-gray-50 hover:bg-ysrcp-50/50 cursor-pointer transition-colors ${
                i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
              }`}
            >
              <td className="py-2.5 px-3 text-gray-400 text-xs">{i + 1}</td>
              <td className="py-2.5 px-3">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-ysrcp-100 to-ysrcp-200 flex items-center justify-center overflow-hidden">
                  {reg.photo_url ? (
                    <img src={reg.photo_url} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <User className="w-3.5 h-3.5 text-ysrcp-400" />
                  )}
                </div>
              </td>
              <td className="py-2.5 px-3 font-medium text-gray-900 max-w-[180px] truncate">{reg.full_name}</td>
              <td className="py-2.5 px-3 text-gray-400 text-xs font-mono max-w-[200px] truncate">{reg.user_id}</td>
              <td className="py-2.5 px-3"><StatusBadge status={reg.status} /></td>
              <td className="py-2.5 px-3 text-gray-600">{reg.committee_type || '—'}</td>
              <td className="py-2.5 px-3 text-gray-600">{reg.position || '—'}</td>
              <td className="py-2.5 px-3 text-gray-600">{reg.mandal || '—'}</td>
              <td className="py-2.5 px-3 text-gray-600">{reg.phone_number || '—'}</td>
              <td className="py-2.5 px-3 text-gray-500 font-mono text-xs">{reg.voter_id || '—'}</td>
              <td className="py-2.5 px-3 text-gray-400 text-xs">{formatShortDate(reg.created_date)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
